import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_filter_date_range extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_filter_date_range">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Filter Date Range</h2>
              <p>
                Filter date range gives the user the ability to restrict a
                results component to a date range on a particular field. The
                date range filter supports both “before” and “after” a specific
                date as well as “between”. The after date value starts at
                00:00:00 where they before date value ends at 23:59:59. So a
                filtered search between 02/06/2016 and 02/06/2016 will include
                all records between 02/06/2016 00:00:00 and 02/06/2016 23:59:59.
              </p>
              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_filter_date_range"}
                name={"filter date range"}
                dataNameDefault={
                  '"date_my_field" or "object_my_obj.date_my_field"'
                }
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={true}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Filter Date Range Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Filter Date Range</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_filter_date_range"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">
                    "object_created_by.date_created"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Created Date"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_filter_date_range;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_filter_date_range.js